// @ts-check
import OutOfGroupModal from './OutOfGroupModal';

export default OutOfGroupModal;
